import React, { useEffect } from "react";
import config from "./config";

const devLog = (...args) => {
  if (config.IS_DEV) {
    console.log(...args);
  }
};

const PricingTable = ({ userId }) => {
  useEffect(() => {
    devLog("Pricing Table loaded with userId:", userId);
  }, [userId]);

  return (
    <div>
      <script async src="https://js.stripe.com/v3/pricing-table.js"></script>
      <stripe-pricing-table
        pricing-table-id="prctbl_1QTY16KtrKYrm82NlqwozTBL"
        publishable-key="pk_live_51QTXXEKtrKYrm82NgIdNkigOOhuORVXrQjAyziAW2GW1yLIn6gg9VN0hj0ct6QaqKmzpXgVWV1C1f6DjNMDHwUjE007KcwbbBe"
        client-reference-id={userId}
      ></stripe-pricing-table>
    </div>
  );
};

export default PricingTable;
